<div class="filters" [class.shrink]="shrinkButtons" *ngIf="enableFilters" [ngClass]="{'hide': !showFilters}">
    <section class="buttons" [attr.aria-label]="filters.labels.wrapper">
        <!--Top Filters Buttons-->
        <finder-filter-button
            class="filter-button"
            *ngFor="let filter of topFilters"
            [id]="filter.id"
            [ariaLabel]="filter.ariaLabel"
            [icon]="filter.icon"
            [selected]="filter.selected"
            (click)="toggleTopFilter(filter)">
            <span>{{filter.label}}</span>
        </finder-filter-button>
    </section>
    <!--Filter Pills-->
    <finder-filter-pills
        class="filter-pills"
        *ngIf="!shrinkButtons && !isMobile"
        [pills]="appliedFacets"
        [clearLabel]="filters.labels.clearAll"
        [pillAriaLabel]="filters.labels.pillAriaLabel"
        [pillsWrapperLabel]="filters.labels.pillsWrapper"
        [clearAriaLive]="filters.labels.allFiltersRemoved"
        [pillAriaLive]="filters.labels.filterRemoved"
        (clear)="clearPills()"
        (pillClose)="closePill($event)">
    </finder-filter-pills>
</div>
